// extracted by mini-css-extract-plugin
export default {"legend":"Style_legend__ROLjt","legendColor":"Style_legendColor__ipLhB","legendLabel":"Style_legendLabel__U50yE"};